/**
 * Created by andrey on 05.11.2025
 */

const IslandDecorationPlanner = function () {
    if (!Map2d.currentMap.regions.islanddecoration || !Map2d.currentMap.regions.islanddecoration.positions[0]) {
        return;
    }

    if (cleverapps.config.editorMode || cleverapps.config.adminMode) {
        return;
    }

    cleverapps.missionManager.on("add", (mission) => this.onAddMission(mission), this);
    cleverapps.missionManager.on("remove", (mission) => this.onRemoveMission(mission), this);

    cleverapps.missionManager.missions.forEach((mission) => this.onAddMission(mission));

    if (!this.islandDecoration) {
        this.spawnStub();
    }
};

IslandDecorationPlanner.prototype.onAddMission = function (mission) {
    if (!mission.islandDecoration) {
        return;
    }

    if (!mission.logic.period) {
        return;
    }

    if (!IslandDecorationHelper.getItemsBundle(mission.logic.period)) {
        return;
    }

    this.removeStub();
    this.spawn(mission);
};

IslandDecorationPlanner.prototype.onRemoveMission = function (mission) {
    if (!mission.islandDecoration) {
        return;
    }

    this.remove(mission);

    if (!this.islandDecoration) {
        this.spawnStub();
    }
};

IslandDecorationPlanner.prototype.spawnStub = function () {
    if (this.islandDecoration || this.stub) {
        return;
    }

    const unit = new Unit({ code: "islanddecoration", stage: 0 });
    this.stub = unit.findComponent(IslandDecorationComponent);
    this.stub.spawn();
};

IslandDecorationPlanner.prototype.removeStub = function () {
    if (!this.stub) {
        return;
    }

    this.stub.remove();
    this.stub = undefined;
};

IslandDecorationPlanner.prototype.spawn = function (mission) {
    if (this.islandDecoration) {
        return;
    }

    const { code, stage } = mission.islandDecoration;
    const unit = new Unit({ code, stage, mission });
    const islandDecoration = this.islandDecoration = unit.findComponent(IslandDecorationComponent);
    islandDecoration.spawn();
};

IslandDecorationPlanner.prototype.remove = function (mission) {
    if (!this.islandDecoration || this.islandDecoration.mission !== mission) {
        return;
    }

    this.islandDecoration.remove();
    this.islandDecoration = undefined;
};

IslandDecorationPlanner.prototype.destructor = function () {
    runCleaners(this);
};
